/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import {
  Container,
  Infos,
  StyledFont,
  KpisList,
  KpisCount,
  EmptyList,
  Title,
  KpiText,
  KpiIdContainer,
} from './styled/ListKpisDependenciesFromColumns.styled';
import { charts } from '../../options';

import DataTable from '../../juristec-ui/core/DataTable';
import TablePagination from '../../juristec-ui/core/TablePagination';
import Tooltip from '../../juristec-ui/core/Tooltip';

const copyToClipboard = (copyText) => {
  navigator.clipboard.writeText(copyText).catch((err) => {
    console.error('Falha ao copiar: ', err);
  });
};

const ListKpisDependenciesFromColumns = ({ kpis, file }) => {
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [copied, setCopied] = useState(false);

  const itemInfo = (kpi, id, name) => (
    <KpiText>
      <h4>{kpi[name] || 'Sem Nome'}</h4>
      <Tooltip text={copied ? 'Copiado!' : 'Clique para copiar'} atModal>
        <KpiIdContainer
          onClick={() => {
            copyToClipboard(kpi[id] || '');
            setCopied(true);
          }}
          onMouseEnter={() => setCopied(false)}
        >
          {kpi[id] || 'Id não encontrado'}
        </KpiIdContainer>
      </Tooltip>
    </KpiText>
  );

  const getType = (kpi) => {
    const type = kpi?.type;
    if (type) {
      return charts[type].label;
    }
    return '';
  };

  const columns = [
    {
      field: 'name',
      label: 'Nome do KPI',
      sortable: true,
      valueGetter: (param) => itemInfo(param, 'id', 'name'),
    },
    {
      field: 'type',
      label: 'Tipo',
      sortable: true,
      valueGetter: (param) => getType(param),
    },
    {
      field: 'ownerEmail',
      label: 'Proprietário',
      sortable: true,
      valueGetter: (param) => itemInfo(param, 'ownerId', 'ownerEmail'),
    },
    {
      field: 'dashboardName',
      label: 'Nome do Dashboard',
      sortable: true,
      valueGetter: (param) => itemInfo(param, 'dashboardId', 'dashboardName'),
    },
  ];

  return (
    <Container>
      <div>
        Os seguintes KPIs poderão ser afetados pela alteração dos tipos das colunas do relatório
        {' '}
        <strong>{file?.filename ?? 'Nome do arquivo não encontrado'}</strong>
        . É provável que, no momento da atualização do relatório, esses KPIs não sejam atualizados
        e precisem ser reconstruídos. Deseja continuar?
      </div>
      <Infos>
        <StyledFont>
          <>
            <Title>Arquivo:</Title>
            {' '}
            <span>{file?.filename ?? 'Nome do arquivo não encontrado'}</span>
          </>
        </StyledFont>
        <KpisCount>
          <StyledFont>
            <Title>KPIs afetados:</Title>
            {' '}
            <span>
              {kpis.length}
            </span>
          </StyledFont>
        </KpisCount>
      </Infos>
      {kpis.length > 0 ? (
        <>
          <KpisList>
            <DataTable
              columns={columns}
              rowData={kpis}
              rowColor={theme.tableBackground}
              strippedRowsColor={theme.containerOdd}
              defaultSortField="name"
              defaultSortOrder="ascending"
              headerColor="transparent"
              theadStyle={{
                position: 'sticky',
                top: 0,
                zIndex: 2,
                backgroundColor: theme.background,
              }}
              tbodyStyle={{
                fontSize: '14px',
              }}
              usePagination
              page={page}
              itemsPerPage={5}
            />
          </KpisList>
          <TablePagination
            page={page}
            setPage={setPage}
            totalPages={
              Math.floor(kpis.length % 5 === 0
                ? (kpis.length / 5) - 1
                : kpis.length / 5)
            }
          />
        </>
      ) : (
        <EmptyList>
          Este arquivo não foi utilizado em nenhum dashboard
        </EmptyList>
      )}
    </Container>
  );
};

ListKpisDependenciesFromColumns.propTypes = {
  kpis: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    ownerEmail: PropTypes.string,

  })),
  file: PropTypes.shape({
    filename: PropTypes.string,
  }),
};

export default ListKpisDependenciesFromColumns;
